export default __webpack_public_path__ + "static/13-9a107ce3fe314ef7f6d266194b93cfe3.webp";